import { createFileRoute } from '@tanstack/react-router';

import { ReviewConversionPage } from '@/areas/flexible-calculations/FlexibleCalculationTemplates/ReviewConversion';
import { canViewFlexibleCalculationTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';
import { SidebarPageContent } from '@/shared/ui/PageLayoutCollapsibleSidebar';

export const Route = createFileRoute(
    '/_authenticated/templates/_sidebar/flexible-calculation/review-conversion/$legacyTemplateId/$flexibleCalculationTemplateId',
)({
    staticData: {
        access: { permissions: canViewFlexibleCalculationTemplates },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return (
        <SidebarPageContent layoutVariant="fullWidth">
            <ReviewConversionPage
                legacyTemplateId={pathParams.legacyTemplateId}
                flexibleCalculationTemplateId={pathParams.flexibleCalculationTemplateId}
            />
        </SidebarPageContent>
    );
}
